import script from "./UserUpdateFormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserUpdateFormView.vue?vue&type=script&setup=true&lang=ts"

import "./UserUpdateFormView.vue?vue&type=style&index=0&id=5a9370bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a9370bc"]])

export default __exports__